import styled from "@emotion/styled";
import * as Dialog from "@radix-ui/react-dialog";

export const ConfirmOverlay = styled(Dialog.Overlay)`
    position: fixed;
    inset: 0;
    @media (min-width: 768px) { left: var(--sidebar-width, 0px); }
    background: rgba(0, 0, 0, 0.5);
    z-index: 2000;
`;

export const ConfirmContent = styled(Dialog.Content)`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    @media (min-width: 768px) { left: calc(50% + var(--sidebar-width, 0px) / 2); }
    width: 311px;
    // min-height: 205px;
    height: auto;

    padding: 24px 20px;
    border-radius: 16px;
    border-width: 1px;
    border-style: solid;
    border-color: #2b2d33;
    background: #1E1F22;
    box-shadow: 0px 12px 32px rgba(0, 0, 0, 0.45);

    display: flex;
    flex-direction: column;
    gap: 16px;
    box-sizing: border-box;
    z-index: 2001;
`;

export const ConfirmTitle = styled.h2`
    margin: 0;
    font-family: Inter, system-ui, sans-serif;
    font-weight: 600;
    font-style: normal;
    font-size: 16px;
    line-height: 120%;
    letter-spacing: 0;
    vertical-align: middle;
    color: #e9ecf5;
`;

export const ConfirmDescription = styled.p`
    margin: 0;
    font-family: Inter, system-ui, sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 14px;
    line-height: 150%;
    letter-spacing: 0;
    vertical-align: middle;
    color: #b7bdcb;
    text-align: center;
`;

export const ConfirmButtonsRow = styled.div`
    width: 271px;
    height: 64px;
    padding: 10px;
    display: flex;
    gap: 12px;
    margin: 0 auto;
    box-sizing: border-box;
    justify-content: space-between;
`;

export const CancelButton = styled.button`
    width: 83px;
    height: 44px;
    padding: 12px 16px;
    border-radius: 12px;
    border: none;
    background: transparent;
    cursor: pointer;

    font-family: Inter, system-ui, sans-serif;
    font-weight: 600;
    font-style: normal;
    font-size: 15px;
    line-height: 140%;
    letter-spacing: 0;
    text-align: center;
    vertical-align: middle;
    color: #b7bdcb;
`;

export const DeleteButton = styled.button`
    min-width: 96px;
    height: 44px;
    padding: 12px 24px;
    border-radius: 12px;
    border: none;
    cursor: pointer;

    background: #d65f46;
    font-family: Inter, system-ui, sans-serif;
    font-weight: 600;
    font-style: normal;
    font-size: 15px;
    line-height: 140%;
    letter-spacing: 0;
    text-align: center;
    vertical-align: middle;
    color: #ffffff;

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`;

export const ErrorText = styled.p`
    margin: 0;
    font-family: Inter, system-ui, sans-serif;
    font-weight: 400;
    font-size: 13px;
    line-height: 140%;
    color: #d65f46;
    text-align: center;
`;
